const language = {
  UNDEFINED: 'Undefined',

  AFRIKAANS: 'Afrikaans',
  AMHARIC: 'Amharic',
  ARABIC: 'Arabic',
  MODERN_STANDARD_ARABIC: 'Modern Standard Arabic',

  AZERBAIJANI: 'Azerbaijani',
  BULGARIAN: 'Bulgarian',
  BENGALI: 'Bengali',
  CATALAN: 'Catalan',
  CZECH: 'Czech',
  DANISH: 'Danish',
  GERMAN: 'German',
  GREEK: 'Greek',

  ENGLISH: 'English',
  AMERICAN_ENGLISH: 'English (US)',
  BRITISH_ENGLISH: 'English (UK)',

  SPANISH: 'Spanish',
  EUROPEAN_SPANISH: 'Spanish (Europe)',
  LATIN_AMERICAN_SPANISH: 'Spanish (Latin America)',

  ESTONIAN: 'Estonian',
  PERSIAN: 'Persian',
  FINNISH: 'Finnish',
  FILIPINO: 'Filipino',
  FRENCH: 'French',
  CANADIAN_FRENCH: 'French (Canada)',

  GUJARATI: 'Gujarati',
  HEBREW: 'Hebrew',
  HINDI: 'Hindi',
  CROATIAN: 'Croatian',
  HUNGARIAN: 'Hungarian',
  ARMENIAN: 'Armenian',
  INDONESIAN: 'Indonesian',
  ICELANDIC: 'Icelandic',
  ITALIAN: 'Italian',
  JAPANESE: 'Japanese',
  GEORGIAN: 'Georgian',
  KAZAKH: 'Kazakh',
  KHMER: 'Khmer',
  KANNADA: 'Kannada',
  KOREAN: 'Korean',
  KIRGHIZ: 'Kyrgyz',
  LAO: 'Lao',

  LITHUANIAN: 'Lithuanian',
  LATVIAN: 'Latvian',

  MACEDONIAN: 'Macedonian',
  MALAYALAM: 'Malayalam',
  MONGOLIAN: 'Mongolian',
  MARATHI: 'Marathi',
  MALAY: 'Malay',
  BURMESE: 'Burmese',
  NEPALI: 'Nepali',

  DUTCH: 'Dutch',

  NORWEGIAN: 'Norwegian',

  PUNJABI: 'Punjabi',
  POLISH: 'Polish',

  PORTUGUESE: 'Portuguese',
  BRAZILIAN_PORTUGUESE: 'Portuguese (Brazil)',
  EUROPEAN_PORTUGUESE: 'Portuguese (Portugal)',

  ROMANIAN: 'Romanian',
  RUSSIAN: 'Russian',
  SINHALA: 'Sinhala',
  SLOVAK: 'Slovak',
  SLOVENIAN: 'Slovenian',
  ALBANIAN: 'Albanian',
  SERBIAN: 'Serbian',
  SERBIAN_LATIN: 'Serbian (Latin)',

  SWEDISH: 'Swedish',
  SWAHILI: 'Swahili',

  TAMIL: 'Tamil',
  TELUGU: 'Telugu',
  THAI: 'Thai',
  TURKISH: 'Turkish',

  UKRAINIAN: 'Ukrainian',
  URDU: 'Urdu',

  UZBEK: 'Uzbek',
  VIETNAMESE: 'Vietnamese',
  CHINESE: 'Chinese',
  SIMPLIFIED_CHINESE: 'Chinese (Simplified)',
  TRADITIONAL_CHINESE: 'Chinese (Traditional)',

  ZULU: 'Zulu'
};

export default language;
